import React from 'react';
import { Link } from 'react-router-dom';

const proofChips = [
  'Artist profile saved',
  'Payment received',
  'Song link submitted',
  'Rights confirmations received',
];

const trustSpine = [
  'Payment gets your record processed.',
  'Excellence earns the next move.',
  'Placement cannot be bought.',
];

const ActionCue = ({ children }) => (
  <span className="hitlab-post-submit-action-cue">{children}</span>
);

export default function HitLabPostSubmitBridge({
  onShareHitLab,
  shareFallbackMessage = '',
  shareState = { message: '', showFallback: false },
  reviewReady = false,
}) {
  return (
    <article
      className="hitlab-receipt-card hitlab-receipt-card-wide hitlab-post-submit-bridge"
      aria-label="JG Universe post-submit bridge"
    >
      <div className="hitlab-post-submit-bridge-header">
        <div>
          <p className="hitlab-kicker">JG UNIVERSE</p>
          <h2>{reviewReady ? "Your record is in. Discover who's already in rotation." : 'Your submission is saved. Discover Joe Galaxy Radio.'}</h2>
          {reviewReady && <p>While your record is with Joe Galaxy for review, discover the artists already on JG Radio.</p>}
        </div>
        <Link
          className="hitlab-primary-btn"
          to="/home?radio=1&source=hitlab-submitted"
        >
          Listen to JG Radio
        </Link>
      </div>

      <div className="hitlab-post-submit-proof-wrap">
        <p className="hitlab-post-submit-proof-label">Your submission path</p>
        <ul
          className="hitlab-post-submit-proof"
          aria-label="HitLab submission proof"
        >
          {proofChips.map((chip) => (
            <li key={chip}>{chip}</li>
          ))}
        </ul>
      </div>

      <div className="hitlab-post-submit-trust" aria-label="HitLab trust spine">
        {trustSpine.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>

      <div className="hitlab-post-submit-core-actions" aria-label="JG Universe next steps">
        <Link
          className="hitlab-post-submit-action"
          to="/home?source=hitlab-submitted"
        >
          <strong>Explore JG Universe</strong>
          <span>
            Meet independent artists and JG Players. Discover what is happening across the community.
          </span>
          <ActionCue>Explore JG Universe -&gt;</ActionCue>
        </Link>

        <Link
          className="hitlab-post-submit-action"
          to="/profile/thejoegalaxy"
        >
          <strong>Connect with @thejoegalaxy</strong>
          <span>
            Find Joe Galaxy inside JG Universe. Follow the public profile, stay
            close to Radio movement, and see what is happening across the
            platform.
          </span>
          <ActionCue>View profile -&gt;</ActionCue>
        </Link>

        <Link
          className="hitlab-post-submit-action"
          to="/home?source=hitlab-first-post"
        >
          <strong>Make your first post</strong>
          <span>
            Tell people you submitted your record to JG HitLab. One
            record. One shot.
          </span>
          <ActionCue>Start on Home -&gt;</ActionCue>
        </Link>

        <button
          type="button"
          className="hitlab-post-submit-action"
          onClick={onShareHitLab}
        >
          <strong>Share JG HitLab</strong>
          <span>I submitted one record to JG HitLab. One record. One shot.</span>
          <ActionCue>Share HitLab -&gt;</ActionCue>
        </button>
      </div>

      <Link
        className="hitlab-post-submit-discovery"
        to="/localops/how-it-works?source=hitlab-submitted"
        aria-label="Explore JG LocalOps discovery"
      >
        <span>
          <strong>Explore JG LocalOps</strong>
          <span>
            Build proof beyond the record. JG LocalOps lets real people
            complete verified actions and build Action Credit through
            real-world work.
          </span>
        </span>
        <ActionCue>Explore LocalOps -&gt;</ActionCue>
      </Link>

      {shareState.message ? (
        <p className="hitlab-share-message">{shareState.message}</p>
      ) : null}
      {shareState.showFallback ? (
        <label className="hitlab-copy-field">
          JG HitLab share message
          <textarea
            readOnly
            value={shareFallbackMessage}
            onFocus={(event) => event.target.select()}
          />
        </label>
      ) : null}
    </article>
  );
}
